// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falChevronUp: CreateIconOptions = {
  "displayName": "FALChevronUp",
  "viewBox": "0, 0, 512, 512",
  "d": "M244.7 116.7c6.2-6.2 16.4-6.2 22.6 0l192 192c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 150.6 75.3 331.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192z"
};
